import {
    CommentFormModal,
    EmojiModal,
    GiFsModal,
    IncidentsFeedCard,
    LayoutLoader,
    MapModal,
    SideNav,
    TopNav,
    TopNewsCard
} from "components";
import LightBox from "components/files/feed/LightBox";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import { Button, SVG } from "ui";
import useScrollY from "utils/hooks/useScrollY";
import { useAllowScroll, useStopScroll } from "utils/hooks/useStopScroll";
import useWindowSize from "utils/hooks/useWindowSize";
import { CustomComponentProps } from "utils/types/generalTypes";

export type FeedLayoutProps = CustomComponentProps & {
    pageTitle: string;
    children: React.ReactNode;
    hideSideCards?: boolean;
};

const FeedLayout = ({
    pageTitle,
    children,
    hideSideCards = false
}: FeedLayoutProps) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [activeClass, setActiveClass] = useState<"active" | "">("");
    const [isFoldClass, setIsFoldClass] = useState<"is-fold" | "">("is-fold");

    const [scrollY, setScrollY] = useState<number>(0);
    useScrollY(setScrollY);

    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    useEffect(() => {
        if (openSidebar) {
            setActiveClass("active");
            setIsFoldClass("");
        } else {
            setActiveClass("");
            setIsFoldClass("is-fold");
        }
    }, [openSidebar]);

    // fix side cards position
    const col4Ref = useRef(null);
    const [fixedDivPosition, setFixedDivPosition] = useState(0);
    const [windowWidth] = useWindowSize();

    const handleSetFixedDivPosition = () => {
        if (hideSideCards) {
            return;
        }
        // @ts-ignore
        const rect = col4Ref.current.getBoundingClientRect();
        // console.log("rect", rect);
        setFixedDivPosition(rect.width);
    };
    useEffect(() => {
        handleSetFixedDivPosition();
    }, []);
    useEffect(() => {
        handleSetFixedDivPosition();
    }, [windowWidth]);

    // handle stop scroll
    const pageScroll = useSelector((state: RootState) => state.site.pageScroll);
    useEffect(() => {
        pageScroll ? useAllowScroll() : useStopScroll();
    }, [pageScroll]);

    // page loader
    const [domLoading, setDomLoading] = useState(true);

    useEffect(() => {
        setDomLoading(false);
    }, []);

    const handleScroll2Top = () => {
        document.body.scrollTo({
            top: 0,
            left: 0,
            // @ts-ignore
            behavior: "smooth" // Optional if you want to skip the scrolling animation
        });
    };

    return (
        <>
            <div className="app-overlay is-sidebar-v1"></div>
            {/* <!-- body --> */}
            <SideNav
                fold={isFoldClass}
                currentPage={pageTitle}
                setOpenSidebar={setOpenSidebar}
                toggle={toggleSidebar}
            />
            <div className={`view-wrapper is-sidebar-v1 ${isFoldClass}`}>
                {/* <!-- top toolbar --> */}
                <div
                    className={`toolbar-v1-fixed-wrap ${isFoldClass} ${
                        scrollY > 80 ? "is-active" : ""
                    }`}
                >
                    <TopNav
                        title={pageTitle}
                        activeClass={activeClass}
                        toggle={toggleSidebar}
                    />
                    <button
                        className={
                            "button d-flex flex-j-center flex-a-center gap-10 is-raised is-rounded primary-button is-solid"
                        }
                        style={{ margin: "auto", marginTop: "20px" }}
                        onClick={handleScroll2Top}
                    >
                        <SVG
                            svg="arrow-left"
                            size={16}
                            style={{ transform: "rotate(90deg)" }}
                        />
                        <div>
                            <img
                                className="posted-avatar"
                                src="https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
                                alt="user 1"
                                style={{ marginLeft: 0 }}
                            />
                            <img
                                className="posted-avatar"
                                src="https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
                                alt="user 2"
                            />
                            <img
                                className="posted-avatar"
                                src="https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
                                alt="user 3"
                            />
                        </div>
                        <span>posted</span>
                    </button>
                </div>

                <div className="activity-feed-wrapper">
                    <div
                        id="main-feed"
                        className="container sidebar-boxed"
                        data-open-sidebar
                        data-page-title="Timeline"
                    >
                        <TopNav
                            title={pageTitle}
                            activeClass={activeClass}
                            toggle={toggleSidebar}
                            // toggle={() => {
                            //     console.log("fuck you");
                            // }}
                        />
                        {/* <!-- Content placeholders at page load -->*/}
                        <LayoutLoader hide={!domLoading} />

                        {/* <!-- Feed page main wrapper --> */}
                        <div id="activity-feed" className="view-wrap true-dom">
                            <div className="columns">
                                {/* <!-- Middle column --> */}
                                <div
                                    className={`column ${hideSideCards ? "" : "is-8"} ${isFoldClass}`}
                                >
                                    {children}
                                </div>
                                {/* <!-- /Middle column --> */}

                                {/* <!-- Right side column --> */}
                                {hideSideCards ? (
                                    ""
                                ) : (
                                    <div
                                        className="column is-4 hide-ipad"
                                        ref={col4Ref}
                                    >
                                        <div
                                            className="layout-right-cards"
                                            style={{
                                                width: fixedDivPosition
                                            }}
                                        >
                                            <TopNewsCard />
                                            <IncidentsFeedCard />
                                        </div>
                                    </div>
                                )}
                                {/* <!-- /Right side column --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <LightBox />
            <CommentFormModal />
            <EmojiModal />
            <GiFsModal />
            <MapModal />
        </>
    );
};

export default FeedLayout;
